module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyMyIgdmlld0JveD0iMCAwIDMyIDIzIj4KICAgIDxwYXRoIGZpbGw9IiMxRTIwMUQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTIxLjIwNSAxLjAwN2ExLjExMiAxLjExMiAwIDAgMC0xLjU4NyAwIDEuMTIgMS4xMiAwIDAgMCAwIDEuNTcxbDguMDQ3IDguMDQ3SDEuMTExQTEuMTA2IDEuMTA2IDAgMCAwIDAgMTEuNzM3YzAgLjYxOS40OTIgMS4xMjcgMS4xMTEgMS4xMjdoMjYuNTU0bC04LjA0NyA4LjAzMmMtLjQyOS40NDQtLjQyOSAxLjE1OSAwIDEuNTg3YTEuMTEyIDEuMTEyIDAgMCAwIDEuNTg3IDBsOS45NTItOS45NTJhMS4wOTMgMS4wOTMgMCAwIDAgMC0xLjU3MWwtOS45NTItOS45NTN6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-black.svg
// module id = 19
// module chunks = 0